import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
// Páginas de Admin
import { ColegiosPage } from "./app/admin/colegios/page";
import { ConfiguracionPage } from "./app/admin/configuracion/page";
import { DashboardPage } from "./app/admin/dashboard/page";
import EjerciciosEducativosPage from "./app/admin/ejercicios-educativos/page";
import { GestionCurricularPage } from "./app/admin/gestion-curricular/page";
import { GestionModoHistoriaPage } from "./app/admin/gestion-modo-historia/page";
import { MallaCurricularPage } from "./app/admin/malla-curricular/page";
import { ModoHistoriaPage } from "./app/admin/modo-historia/page";
import { ReportesPage } from "./app/admin/reportes/page";
import SimulacionesPageAdmin from "./app/admin/simulaciones/page";
import { UsuariosPage } from "./app/admin/usuarios/page";
// Páginas de Profesor
import { ProfesorAlumnosPage } from "./app/profesor/alumnos/page";
import AsistenciaPage from "./app/profesor/asistencia/AsistenciaPage";
import { ProfesorConfiguracionPage } from "./app/profesor/configuracion/page";
import { ProfesorCursosPage } from "./app/profesor/cursos/page";
import { ProfesorDashboardPage } from "./app/profesor/dashboard/page";
import { ProfesorReportesPage } from "./app/profesor/reportes/page";
import { SimcePage } from "./app/profesor/simce/page";
import SimulacionesPageProfesor from "./app/profesor/simulaciones/page";
//paginas admin-colegio
import AdminColegioAdministrarPage from "./app/admin-colegio/administrar/page";
import AdminColegioCalendarioPage from "./app/admin-colegio/calendario/page";
import AdminColegioDashboardPage from "./app/admin-colegio/dashboard/page";
import AdminColegioReportesPage from "./app/admin-colegio/reportes/page";
// Páginas compartidas (Auth, etc.)
import AdminColegioPage from "./app/admin-colegio/dashboard/page";
import { LoginPage } from "./app/shared/auth/page";
import { ForgotPasswordPage } from "./app/shared/forgot-password/page";
import { RegisterPage } from "./app/shared/register/page";
import { ResetPasswordPage } from "./app/shared/reset-password/page";
import { UnauthorizedPage } from "./app/shared/unauthorized/page";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import "./index.css";

// Crear cliente de React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Rutas públicas */}
              <Route path="/auth" element={<LoginPage />} />
              <Route path="/login" element={<Navigate to="/auth" replace />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Rutas de administración */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/gestion-curricular"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <GestionCurricularPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/malla-curricular"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <MallaCurricularPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/gestion-modo-historia"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <GestionModoHistoriaPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/modo-historia"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <ModoHistoriaPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/usuarios"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <UsuariosPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/colegios"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <ColegiosPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/ejercicios-educativos"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <EjerciciosEducativosPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/reportes"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <ReportesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/simulaciones"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <SimulacionesPageAdmin />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin-colegio"
                element={
                  <ProtectedRoute requiredRoles={["ADMINCOLEGIO"]}>
                    <AdminColegioPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/asistencia"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <AsistenciaPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/configuracion"
                element={
                  <ProtectedRoute requiredRoles={["ADMIN"]}>
                    <ConfiguracionPage />
                  </ProtectedRoute>
                }
              />

              {/* Rutas de profesor */}
              <Route
                path="/profesor"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <ProfesorDashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/alumnos"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <ProfesorAlumnosPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/cursos"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <ProfesorCursosPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/simulaciones"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <SimulacionesPageProfesor />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/simce"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <SimcePage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/reportes"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <ProfesorReportesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/profesor/configuracion"
                element={
                  <ProtectedRoute requiredRoles={["PROFESOR"]}>
                    <ProfesorConfiguracionPage />
                  </ProtectedRoute>
                }
              />

              {/*ruta admin-colegio*/}
              <Route
                path="/admin-colegio"
                element={
                  <ProtectedRoute requiredRoles={["ADMINCOLEGIO"]}>
                    <AdminColegioDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-colegio/dashboard"
                element={<Navigate to="/admin-colegio" replace />}
              />

              <Route
                path="/admin-colegio/administrar"
                element={
                  <ProtectedRoute requiredRoles={["ADMINCOLEGIO"]}>
                    <AdminColegioAdministrarPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-colegio/calendario"
                element={
                  <ProtectedRoute requiredRoles={["ADMINCOLEGIO"]}>
                    <AdminColegioCalendarioPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin-colegio/reportes"
                element={
                  <ProtectedRoute requiredRoles={["ADMINCOLEGIO"]}>
                    <AdminColegioReportesPage />
                  </ProtectedRoute>
                }
              />

              {/* Página de no autorizado */}
              <Route path="/unauthorized" element={<UnauthorizedPage />} />

              {/* Redirección por defecto */}
              <Route path="/" element={<Navigate to="/admin" replace />} />

              {/* Ruta 404 */}
              <Route
                path="*"
                element={
                  <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                      <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        404
                      </h1>
                      <p className="text-xl text-gray-600">
                        Página no encontrada
                      </p>
                    </div>
                  </div>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
